import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>

      <section className="mb-4">
        <h2 className="text-lg font-semibold">1. Introduction</h2>
        <p>
          Mandya Tourism ("we," "our," "us") respects your privacy. This Privacy
          Policy explains how we handle user information when you use our
          mobile application ("App").
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-lg font-semibold">2. Information We Collect</h2>
        <p>
          Our App does not collect any personal or sensitive user data. However,
          we use third-party SDKs to fetch data from our servers.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-lg font-semibold">3. How We Use Your Information</h2>
        <p>
          Since we do not collect personal data, the information retrieved via
          third-party SDKs is solely used to provide and improve app
          functionality.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-lg font-semibold">4. Sharing of Information</h2>
        <p>
          We do not sell, trade, or rent user data. However, third-party SDKs may
          process data retrieved from our servers as per their respective
          privacy policies.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-lg font-semibold">5. Data Security</h2>
        <p>
          We implement appropriate security measures to protect any data accessed
          via third-party SDKs from unauthorized access, alteration, disclosure,
          or destruction.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-lg font-semibold">6. Data Retention & Deletion</h2>
        <p>
          As we do not collect personal data, retention is not applicable. Any
          requests related to third-party data handling should be directed to the
          respective third-party providers.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-lg font-semibold">7. Your Rights</h2>
        <p>
          Since no personal data is collected, users do not need to request data
          access or deletion. However, users may contact us for any
          privacy-related concerns.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="text-lg font-semibold">8. Contact Us</h2>
        <p>
          If you have questions or concerns about this Privacy Policy, please
          contact us at:
        </p>
        <ul className="list-disc ml-6">
          <li>Email: tourismmandya@gmail.com</li>
          <li>Website: <a href="https://mandyatourism.com" className="text-blue-500 underline">https://mandyatourism.com</a></li>
        </ul>
      </section>

      <section className="mb-4">
        <h2 className="text-lg font-semibold">9. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will
          be posted with an updated effective date.
        </p>
      </section>

      <p className="mt-4 text-sm">
        By using our App, you agree to the terms outlined in this Privacy Policy.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
